import { useState } from 'react';

import { CheckIcon, ChevronsUpDownIcon } from 'lucide-react';

import { cn } from '../lib/utils';

import { Button } from './button';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from './command';
import { Popover, PopoverContent, PopoverTrigger } from './popover';

interface ComboboxProps {
  disabled?: boolean;
  onSelect: (value: string) => void;
  options: { value: string; label: string }[];
  placeholder: string;
  searchPlaceholder: string;
  value: string;
}

export const Combobox = ({
  disabled,
  onSelect,
  options,
  placeholder,
  searchPlaceholder,
  value,
}: ComboboxProps) => {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="vai-justify-between vai-w-full"
          disabled={disabled}
        >
          {value
            ? options.find((option) => option.value === value)?.label
            : placeholder}
          <ChevronsUpDownIcon className="vai-ml-2 vai-h-4 vai-w-4 vai-shrink-0 vai-opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="!vai-p-0">
        <Command>
          <CommandInput placeholder={searchPlaceholder} />
          <CommandList>
            <CommandEmpty className="vai-py-2 vai-text-center vai-text-sm">
              No options found.
            </CommandEmpty>
            <CommandGroup>
              {options.map((option) => (
                <CommandItem
                  key={option.value}
                  value={option.value}
                  onSelect={(newValue: string) => {
                    onSelect(newValue);
                    setOpen(false);
                  }}
                >
                  <CheckIcon
                    className={cn(
                      'vai-mr-2 vai-h-4 vai-w-4',
                      value === option.value
                        ? 'vai-opacity-100'
                        : 'vai-opacity-0',
                    )}
                  />
                  {option.label}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
